import * as React from "react";
import "../../../assets/sass/main.scss";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

const Confirmation = ({
  onClose,
  onCreateAlert,
  onQuickAlert,
  onEditQuickAlert,
  isEditAlert,
  isQuickAlert,
  isEditQuickAlert,
  confirmationBoxText,
  allClearChecked,
  alertMessage,
  alertHeading,
  saveAsQuickAlertChecked,
  setSaveAsQuickAlertChecked,
  buttonLabelText,
  setButtonLabelText,
  quickAlertButtonLabelError,
  isQuickAlertsValidationLoading,
}) => {
  const isSendNowChecked: boolean = confirmationBoxText?.isSendNow;
  const formattedStartTime: string = new Date(
    `2023-01-01T${confirmationBoxText?.startTime}`
  )?.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  const formattedEndTime: string = new Date(
    `2023-01-01T${confirmationBoxText?.endTime}`
  )?.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  const parseDate = (dateString: string) => {
    const [day, month, year] = dateString.split("/");
    return new Date(`${year}-${month}-${day}`);
  };
  const formattedStartDate: string = parseDate(
    confirmationBoxText?.startDate
  ).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const formattedEndDate: string = parseDate(
    confirmationBoxText?.endDate
  ).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const groupDisplayNames: string[] = confirmationBoxText?.groups.map(
    (group) => group.displayName
  );

  const timezone: string = confirmationBoxText?.timeZone;

  let confirmationText: string;

  if (isQuickAlert || isEditQuickAlert) {
    confirmationText = `Your Quick Alert will be saved in “${groupDisplayNames.join(
      ", "
    )}” groups.`;
  } else {
    confirmationText = `Your alert will be sent to “${groupDisplayNames.join(
      ", "
    )}” at ${formattedStartTime} ${timezone} on ${formattedStartDate} and will end at ${formattedEndTime} ${timezone} on ${formattedEndDate}.`;
  }

  const nonScheduledConfirmationText: string =
    isQuickAlert || isEditQuickAlert
      ? `Your Quick Alert will be saved in “${groupDisplayNames.join(
          ", "
        )}" groups.`
      : `Your alert will be sent to “${groupDisplayNames.join(
          ", "
        )}” immediately.`;

  return (
    <div className="confirmation-container">
      <Col sm={8}>
        <div className="alert-select-group">
          <div className="alert-select-bg">
            <div className="alert-select-group-text-heading">
              {alertHeading !== "" ? alertHeading : null}
            </div>
            <div className="alert-select-group-text">{alertMessage}</div>
          </div>
        </div>
        <div className="alert-select-group-label">
          {isSendNowChecked || allClearChecked
            ? nonScheduledConfirmationText
            : confirmationText}
        </div>
      </Col>
      <div>
        <Modal.Footer className="d-flex justify-content-between px-0">
          <div className="d-flex gap-2 align-items-baseline">
            {!isEditAlert &&
              (isQuickAlert || isEditQuickAlert ? (
                <>
                  <label className="quick-alert-button-label">
                    Alert Button Label
                  </label>
                  <div className="quick-alert-button-text ms-3">
                    <Form.Control
                      type="text"
                      placeholder="Enter Quick Alert Name"
                      value={buttonLabelText}
                      onChange={(e) => setButtonLabelText(e.target.value)}
                      maxLength={25}
                      style={{ width: "200px" }}
                      required
                    />
                    <small
                      style={{
                        color: buttonLabelText.length === 25 ? "red" : "#666",
                      }}
                    >
                      Character Limit: {buttonLabelText.length}/25 characters
                    </small>
                    {isQuickAlertsValidationLoading ? (
                      <div className="text-muted small mt-1">Checking for duplicates...</div>
                    ) : quickAlertButtonLabelError ? (
                      <div className="text-danger small mt-1" role="alert">
                        {quickAlertButtonLabelError}
                      </div>
                    ) : null}
                  </div>
                </>
              ) : (
                <>
                  <Form.Check
                    type="switch"
                    id={`Quick-alerts-switch`}
                    checked={saveAsQuickAlertChecked}
                    onChange={() =>
                      setSaveAsQuickAlertChecked(!saveAsQuickAlertChecked)
                    }
                    label={`Save Alert as ${
                      !saveAsQuickAlertChecked ? "Quick Alert" : ""
                    }`}
                  />
                  {saveAsQuickAlertChecked && (
                    <div>
                      <Form.Control
                        type="text"
                        placeholder="Enter Quick Alert Label"
                        value={buttonLabelText}
                        onChange={(e) => setButtonLabelText(e.target.value)}
                        maxLength={25}
                        style={{ width: "200px" }}
                        required
                      />
                      <small
                        style={{
                          color: buttonLabelText.length === 25 ? "red" : "#666",
                        }}
                      >
                        Character Limit: {buttonLabelText.length}/25 characters
                      </small>
                      {isQuickAlertsValidationLoading ? (
                        <div className="text-muted small mt-1">Checking for duplicates...</div>
                      ) : quickAlertButtonLabelError ? (
                        <div className="text-danger small mt-1" role="alert">
                          {quickAlertButtonLabelError}
                        </div>
                      ) : null}
                    </div>
                  )}
                </>
              ))}
          </div>
          <div className="d-flex gap-3">
            <Button className="btn-cancel" onClick={onClose}>
              Cancel
            </Button>

            {(isQuickAlert || isEditQuickAlert) && (
              <Button
                className="btn-style"
                onClick={isEditQuickAlert ? onEditQuickAlert : onQuickAlert}
                disabled={
                  buttonLabelText.trim() === "" ||
                  !!quickAlertButtonLabelError ||
                  isQuickAlertsValidationLoading
                }
              >
                {isEditQuickAlert ? "Edit" : "Create"}
              </Button>
            )}

            {!isQuickAlert && !isEditQuickAlert && (
              <Button
                className="btn-style"
                onClick={onCreateAlert}
                disabled={
                  !isEditAlert &&
                  saveAsQuickAlertChecked &&
                  (buttonLabelText.trim() === "" ||
                    !!quickAlertButtonLabelError ||
                    isQuickAlertsValidationLoading)
                }
              >
                {isEditAlert
                  ? "Edit"
                  : saveAsQuickAlertChecked
                  ? "Create and Save"
                  : "Create"}
              </Button>
            )}
          </div>
        </Modal.Footer>
      </div>
    </div>
  );
};

export default Confirmation;
